const init = () => {
	document.addEventListener('DOMContentLoaded', function () {
		jQuery('.testimonial-slider').slick({
			slidesToShow: 2,
			slidesToScroll: 1,
			variableWidth: true,
			centerMode: false,
			arrows: true,
			dots: true,
			infinite: true,
			prevArrow: `
        <button class="slick-prev icon-bg white">
            <span class="slick-left"></span>
        </button>`,
			nextArrow: `
        <button class="slick-next icon-bg white">
            <span class="slick-right"></span>
        </button>`,
			responsive: [
				{
					breakpoint: 1440,
					settings: {
						slidesToShow: 1,
					},
				},
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
					},
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
					},
				},
			],
		});
	});
};

export { init };
